import { Voyage } from '../types/voyage';

export const mockVoyages: Voyage[] = [
  {
    id: 'VOY001',
    voyageNumber: 'V-2026-001',
    shipId: 'SHP001',
    shipName: '한라호',
    departurePort: { name: '부산항', country: '대한민국', code: 'KRPUS' },
    arrivalPort: { name: '로테르담항', country: '네덜란드', code: 'NLRTM' },
    departureDate: '2026-01-15',
    estimatedArrival: '2026-02-20',
    status: '운항중',
    cargoType: '컨테이너 화물',
    cargoWeight: 45000,
    fuelConsumption: 3200,
    distance: 11200,
    progress: 72,
  },
  {
    id: 'VOY002',
    voyageNumber: 'V-2026-002',
    shipId: 'SHP003',
    shipName: '지리산호',
    departurePort: { name: '울산항', country: '대한민국', code: 'KRUSN' },
    arrivalPort: { name: '도쿄항', country: '일본', code: 'JPTYO' },
    departureDate: '2026-02-01',
    estimatedArrival: '2026-02-05',
    actualArrival: '2026-02-05',
    status: '완료',
    cargoType: '원유',
    cargoWeight: 95000,
    fuelConsumption: 850,
    distance: 1100,
    progress: 100,
  },
  {
    id: 'VOY003',
    voyageNumber: 'V-2026-003',
    shipId: 'SHP005',
    shipName: '태백호',
    departurePort: { name: '싱가포르항', country: '싱가포르', code: 'SGSIN' },
    arrivalPort: { name: '함부르크항', country: '독일', code: 'DEHAM' },
    departureDate: '2026-01-20',
    estimatedArrival: '2026-03-01',
    status: '운항중',
    cargoType: '컨테이너 화물',
    cargoWeight: 38000,
    fuelConsumption: 2800,
    distance: 9800,
    progress: 55,
  },
  {
    id: 'VOY004',
    voyageNumber: 'V-2026-004',
    shipId: 'SHP007',
    shipName: '독도호',
    departurePort: { name: '광양항', country: '대한민국', code: 'KRKWG' },
    arrivalPort: { name: '시드니항', country: '호주', code: 'AUSYD' },
    departureDate: '2026-02-10',
    estimatedArrival: '2026-03-05',
    status: '운항중',
    cargoType: '철광석',
    cargoWeight: 72000,
    fuelConsumption: 1500,
    distance: 5200,
    progress: 28,
  },
  {
    id: 'VOY005',
    voyageNumber: 'V-2026-005',
    shipId: 'SHP008',
    shipName: '울릉호',
    departurePort: { name: '평택항', country: '대한민국', code: 'KRPTK' },
    arrivalPort: { name: 'LA항', country: '미국', code: 'USLAX' },
    departureDate: '2026-01-28',
    estimatedArrival: '2026-02-25',
    status: '운항중',
    cargoType: '자동차',
    cargoWeight: 12000,
    fuelConsumption: 2100,
    distance: 5800,
    progress: 68,
  },
  {
    id: 'VOY006',
    voyageNumber: 'V-2026-006',
    shipId: 'SHP010',
    shipName: '소백호',
    departurePort: { name: '라스라판항', country: '카타르', code: 'QARLF' },
    arrivalPort: { name: '인천항', country: '대한민국', code: 'KRINC' },
    departureDate: '2026-02-05',
    estimatedArrival: '2026-03-02',
    status: '운항중',
    cargoType: 'LNG',
    cargoWeight: 70000,
    fuelConsumption: 1800,
    distance: 7500,
    progress: 42,
  },
  {
    id: 'VOY007',
    voyageNumber: 'V-2026-007',
    shipId: 'SHP002',
    shipName: '백두호',
    departurePort: { name: '인천항', country: '대한민국', code: 'KRINC' },
    arrivalPort: { name: '상하이항', country: '중국', code: 'CNSHA' },
    departureDate: '2026-02-20',
    estimatedArrival: '2026-02-24',
    status: '예정',
    cargoType: '곡물',
    cargoWeight: 55000,
    fuelConsumption: 0,
    distance: 850,
    progress: 0,
  },
  {
    id: 'VOY008',
    voyageNumber: 'V-2026-008',
    shipId: 'SHP009',
    shipName: '한강호',
    departurePort: { name: '대산항', country: '대한민국', code: 'KRDAS' },
    arrivalPort: { name: '주바일항', country: '사우디', code: 'SAJUB' },
    departureDate: '2026-02-25',
    estimatedArrival: '2026-03-15',
    status: '예정',
    cargoType: '석유제품',
    cargoWeight: 88000,
    fuelConsumption: 0,
    distance: 8200,
    progress: 0,
  },
  {
    id: 'VOY009',
    voyageNumber: 'V-2025-045',
    shipId: 'SHP001',
    shipName: '한라호',
    departurePort: { name: '로테르담항', country: '네덜란드', code: 'NLRTM' },
    arrivalPort: { name: '부산항', country: '대한민국', code: 'KRPUS' },
    departureDate: '2025-11-10',
    estimatedArrival: '2025-12-15',
    actualArrival: '2025-12-18',
    status: '지연',
    cargoType: '컨테이너 화물',
    cargoWeight: 42000,
    fuelConsumption: 3500,
    distance: 11200,
    progress: 100,
  },
  {
    id: 'VOY010',
    voyageNumber: 'V-2025-044',
    shipId: 'SHP003',
    shipName: '지리산호',
    departurePort: { name: '도쿄항', country: '일본', code: 'JPTYO' },
    arrivalPort: { name: '울산항', country: '대한민국', code: 'KRUSN' },
    departureDate: '2025-12-20',
    estimatedArrival: '2025-12-23',
    actualArrival: '2025-12-23',
    status: '완료',
    cargoType: '원유',
    cargoWeight: 90000,
    fuelConsumption: 780,
    distance: 1050,
    progress: 100,
  },
  {
    id: 'VOY011',
    voyageNumber: 'V-2026-009',
    shipId: 'SHP006',
    shipName: '금강호',
    departurePort: { name: '여수항', country: '대한민국', code: 'KRYOS' },
    arrivalPort: { name: '자카르타항', country: '인도네시아', code: 'IDJKT' },
    departureDate: '2026-03-01',
    estimatedArrival: '2026-03-12',
    status: '예정',
    cargoType: 'LPG',
    cargoWeight: 35000,
    fuelConsumption: 0,
    distance: 3400,
    progress: 0,
  },
  {
    id: 'VOY012',
    voyageNumber: 'V-2025-043',
    shipId: 'SHP005',
    shipName: '태백호',
    departurePort: { name: '부산항', country: '대한민국', code: 'KRPUS' },
    arrivalPort: { name: '싱가포르항', country: '싱가포르', code: 'SGSIN' },
    departureDate: '2025-12-28',
    estimatedArrival: '2026-01-08',
    actualArrival: '2026-01-07',
    status: '완료',
    cargoType: '컨테이너 화물',
    cargoWeight: 35000,
    fuelConsumption: 1600,
    distance: 2800,
    progress: 100,
  },
];
